import { useQuery } from 'react-query';
import { handleRequest } from '../../../../redux/services/APIService';
import storageHelper from '../../../../libs/storageHelper';

export function getSessionFacilityServicesSeed() {
  const isBoardingOnly = storageHelper.getFromStorage('loggedUser')?.user
    ?.isBoardingOnly;

  if (typeof isBoardingOnly !== 'boolean') {
    return undefined;
  }

  return {
    isBoardingOnly,
    ...(isBoardingOnly
      ? { boardingOffered: true, veterinaryOffered: false }
      : {}),
  };
}

export const useGetFacilityServices = () => {
  return useQuery(
    ['getFacilityServices'],
    async () => {
      const { user } = storageHelper.getFromStorage('loggedUser');
      const response = await handleRequest(
        'get',
        `facility/${user.facility}`,
        true,
      );
      const services = response.data?.services || { veterinaryOffered: true };
      return {
        ...services,
        isBoardingOnly:
          services.boardingOffered === true &&
          services.veterinaryOffered === false,
      };
    },
    {
      initialData: getSessionFacilityServicesSeed(),
      onError: (error) => {
        console.error(
          `${error.response?.data?.data?.resultMessage || error.message}`,
        );
      },
    },
  );
};
